<dt-modal-content (closeClick)="close()">
  <ng-template #title>
    @if (question) {
      <ng-container i18n>Entscheidungsfrage bearbeiten</ng-container>
    } @else {
      <ng-container i18n>Entscheidungsfrage hinzufügen</ng-container>
    }
  </ng-template>
  <ng-template #content>
    <form [formGroup]="formGroup" (ngSubmit)="save()">
      <mat-form-field>
        <mat-label i18n>Deutscher Name</mat-label>
        <input matInput type="text" formControlName="nameDe" />
      </mat-form-field>
      <mat-form-field>
        <mat-label i18n>Englischer Name</mat-label>
        <input matInput type="text" formControlName="nameEn" />
      </mat-form-field>

      <dt-tag-input formControlName="tags" [allTags]="tags" i18n>Tags</dt-tag-input>

      <div class="buttons-wrapper">
        <button
          mat-raised-button
          color="primary"
          type="submit"
          [dtOverlayProgress]="formGroup.disabled"
          [disabled]="formGroup.disabled || formGroup.invalid"
          i18n
          >Speichern</button
        >
        <button mat-stroked-button type="reset" (click)="close()" [disabled]="formGroup.disabled" i18n>Verwerfen</button>
        @if (question) {
          <button mat-stroked-button color="warn" type="button" (click)="delete()" [disabled]="formGroup.disabled" i18n
            >Entscheidungsfrage löschen</button
          >
        }
      </div>
    </form>
  </ng-template>
</dt-modal-content>
